import { formatReviewString } from './formatter'
import {
  hhs_business_units,
  office_of_the_secretary,
  hhs_programs,
  dont_know
} from 'hotline_complaint_choices'

const dontKnow = Object.keys(dont_know)[0]
const dontKnowLabel = Object.values(dont_know)[0]

export const reviewHhsPrograms = values => {
  const { business_unit, hhs_program, hhs_program_detail } = values
  const os_value = values.office_of_secretary

  let review = [
    {
      heading: 'Program',
      field_name: 'hhs_program',
      value: formatReviewString(getLabel(hhs_program, hhs_programs))
    }
  ]

  if (hhs_program === 'OS') {
    review = review.concat([
      {
        heading: 'Office of Secretary',
        field_name: 'office_of_the_secretary',
        value: formatReviewString(getLabel(os_value, office_of_the_secretary))
      }
    ])
  }

  if (!doesntKnow(hhs_program) && !doesntKnow(os_value) && hhs_program!= 'FRAUD_GOV') {
    review = review.concat([
      {
        heading: 'Business unit',
        field_name: 'business_unit',
        value: formatReviewString(
          getBusinessUnit(hhs_program, os_value, business_unit)
        )
      }
    ])
  }

  review = review.concat([
    {
      heading: 'Office name',
      field_name: 'hhs_program_detail',
      value: formatReviewString(hhs_program_detail)
    }
  ])

  return review
}

const doesntKnow = val => val === dontKnow
const getLabel = (value, hash) =>
  doesntKnow(value) ? dontKnowLabel : hash[value]
const getBusinessUnit = (program, secretary, unit) =>
  program === 'OS'
    ? getLabel(unit, hhs_business_units[secretary])
    : getLabel(unit, hhs_business_units[program])
